import { useEffect, useRef } from 'react';
import styles from './TakeSnapshot.module.css';

const TakeSnapshot = ({ videoElementId, snapshotFileType, onSnapshot, id, imageQuality = 1 }) => {
    const canvasRef = useRef();

    const videoElement = document.getElementById(videoElementId);
    const container = videoElement.closest(`div[id="video-container__${videoElementId}"]`);

    const intrinsicWidth = videoElement.videoWidth;
    const intrinsicHeight = videoElement.videoHeight;

    const { x: videoX, y: videoY, height: videoHeight, width: videoWidth } = videoElement.getBoundingClientRect();
    const { width: containerWidth, height: containerHeight, x: containerX, y: containerY } = container.getBoundingClientRect();

    let scale, x, y, relativeWidth, relativeHeight, width, height;

    let angle = 0;
    const style = videoElement.getAttribute('style');
    if (style) {
        const angleMatch = style.match(/rotate\((-?\d+)deg\)/);
        if (angleMatch && angleMatch[1]) angle = parseInt(angleMatch[1], 10);
    }

    if (angle === 270 || angle === 90) {
        scale = intrinsicHeight / videoWidth;
        width = containerWidth * scale || intrinsicWidth;
        height = containerHeight * scale || intrinsicHeight;
        relativeWidth = height;
        relativeHeight = width;
        if (angle === 270) {
            x = videoY + videoHeight - containerY - containerHeight;
            y = containerX - videoX;
        } else {
            x = containerY - videoY;
            y = videoX + videoWidth - containerX - containerWidth;
        }
    }

    if (angle === 0 || angle === 180) {
        scale = intrinsicHeight / videoHeight;
        width = containerWidth * scale || intrinsicWidth;
        height = containerHeight * scale || intrinsicHeight;
        relativeHeight = height;
        relativeWidth = width;
        if (angle === 0) {
            x = containerX - videoX;
            y = containerY - videoY;
        }
        if (angle === 180) {
            x = videoX + videoWidth - containerX - containerWidth;
            y = videoY + videoHeight - containerY - containerHeight;
        }
    }
    useEffect(() => {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
        context.fillStyle = '#f0f0f0';
        context.fillRect(0, 0, canvas.width, canvas.height);
        let canvasRelativeWidth, canvasRelativeHeigth;
        canvasRelativeWidth = canvas.width;
        canvasRelativeHeigth = canvas.height;
        if (angle) {
            if (angle === 270 || angle === 90) {
                canvasRelativeWidth = canvas.height;
                canvasRelativeHeigth = canvas.width;
            }
            context.translate(canvas.width / 2, canvas.height / 2);
            context.rotate((angle * Math.PI) / 180);
            context.translate(-canvasRelativeWidth / 2, -canvasRelativeHeigth / 2);
        }
        context.drawImage(videoElement, x * scale, y * scale, relativeWidth, relativeHeight, 0, 0, canvasRelativeWidth, canvasRelativeHeigth);
        const base64 = canvas.toDataURL(snapshotFileType || 'image/jpeg', imageQuality);
        onSnapshot(id, base64);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoElement, intrinsicWidth, intrinsicHeight]);

    return <canvas className={styles.canvas} ref={canvasRef} width={width} height={height}></canvas>;
};

export default TakeSnapshot;
